import * as React from "react";
import { RecentMediaLinesDocItem } from './doc-item';
import { ItemSearchModel } from "../../model/autogen/ItemSearchModel";

export interface IDocListProps {
    items: ItemSearchModel[];
    showAttachments?: boolean;
}

const RecentMediaLinesDocList = (props: IDocListProps) => {
    const items = [...props.items].filter((x=>x.priority !== undefined && x.priority !== null && x.priority >= 0)).sort((x:any, y:any)=>(x.priority - y.priority));

    console.log('RecentMediaLinesDocList', props.items);
    return <div>
        {items.map((x:any, i:any) => <RecentMediaLinesDocItem showAttachments={props.showAttachments} {...x} key={i} />)}
    </div>;
}

export default RecentMediaLinesDocList;


// WEBPACK FOOTER //
// ./src/components/doclist/index.tsx